module.exports = __webpack_public_path__ + "img/icon-supervisor-account.2a5089db.svg";